export default {
  title: 'Support Pet Care Note',
  subtitle: 'Your support fuels our mission to build better tools for pet parents',
  oneTime: 'One-Time',
  monthly: 'Monthly',
  oneTimeDescription: 'Give us a one-time boost to keep improving the tools you love',
  monthlyDescription: 'Become a sustaining supporter and grow with Pet Care Note every step of the way',
  chooseAmount: 'Choose Your Support Level',
  month: '/mo',
  kittenSupport: 'Kitten Guardian',
  puppySupport: 'Puppy Guardian',
  bunnySupport: 'Bunny Guardian',
  securePayment: 'Secured by Stripe encryption',
  linkNotConfigured: 'Payment link not configured. Please contact our team.'
};